import ActionTypes from "../../enums/ActionTypes"
import { createAction } from "../../utils/redux"

export const saveSettingsAfterGraphQL = settings => createAction(ActionTypes.GLOBALSETTINGS_FETCH_SUCCESS, settings)
